import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as httpService from '../../services/HTTPService';
// import { redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/authContext';
import SpinLoader from '../spin-loader';
import { hideOverlay } from '../../utils/utils';
import SocialButtons from '../social-buttons';

// type GoogleLoginProp = GoogleLoginProps & {
//     className?: any
// }

function ContactForm() {
  const { t, i18n } = useTranslation();  
  const sendLbl = i18n.exists("forms.send") ? t('forms.send') : "Изпрати";
  const namesLbl = i18n.exists("forms.names") ? t('forms.names') : "Имена";
  const messageLbl = i18n.exists("forms.message") ? t('forms.message') : "Съобщение"; 
  const messageSentLbl = i18n.exists("forms.messageSentLbl") ? t('forms.messageSentLbl') : 'Вашето съобщение е изпратено успешно!'; 
  const [visibleErrors, setVisibleErrors] = useState(true);

  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const defaultFormData = {
    email: "",
    fullName: "",
    message: "",
    phoneNumber: ""
  }
  let [conactForm, setContactForm] = useState(defaultFormData);
  let [isSpinning, setIsSpinning] = useState(false);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    setVisibleErrors(true);
    event.preventDefault();
    event.stopPropagation();
    const form: any = event.currentTarget;
    let contactData: any  = {...conactForm};
    const data:any = new FormData(event.currentTarget);
    //let formObject = Object.fromEntries(data.entries())
    let d = data.entries();
    for (let [key, value] of d) {
        contactData[key] = value;
        //console.log(key, value);
    }
    if(form[2].id === "message") {
        contactData['message'] = form[2].value;
    }
    conactForm = contactData;
    setContactForm(contactData);
    
    if (form.checkValidity() === true) {
        sendMessage(conactForm);
        resetForm(form);
    }
    setValidated(true);
  };

  const resetForm = (form: any) => {
    form.reset();
    setVisibleErrors(false);
    //let formEl: any = document.getElementById('contact-form');
    //formEl.setAttribute('novalidate', '');
    //formEl.classList.remove('was-validated');
    //let validity: any = form.checkValidity();
    //validity = false;
    setValidated(false);
    //formEl.checkValidity() = validity
    // let email: any = document.getElementById('email');
    // let names: any = document.getElementById('names');
    // let message: any = document.getElementById('message');
    // if(names) {
    //     names.value = '';
    // }
    // if(email) {
    //     email.value = '';
    // }
    // if(message) {
    //     message.value = '';
    // }
  }

  const sendMessage = (data: any) => {
    //setIsSpinning(true);
    //toast.success(messageSentLbl);

    //console.log(data);
    httpService.sendMessage(data).then((res) => {
        if(res) {
            //console.log(res);
            toast.success(messageSentLbl);
            hidePreloader();
        }
    })
    .catch((err) => {
        console.log(err);
        hidePreloader();
        toast.error(t('forms.commonErrMsg'));
    })
  }

    const hidePreloader = () => {
        hideOverlay();
        setIsSpinning(false);
    }

  return (
    <div>
        <ToastContainer position="top-center"
 />
        <Form id="contact-form" noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Col lg="6">
                    <Form.Group as={Col} md="12" controlId="email">
                        <Form.Label>{t('forms.email')}*</Form.Label>
                        <Form.Control 
                            type="email"
                            name="email"
                            required={visibleErrors}
                        />
                    <Form.Control.Feedback type="invalid">
                                {t('forms.validEmailError')}
                            </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="12" controlId="fullName">
                        <Form.Label>{namesLbl}*</Form.Label>
                        <Form.Control 
                            type="text"
                            name="fullName"
                            required={visibleErrors}
                        />
                        <Form.Control.Feedback type="invalid">
                                {t('forms.requiredFieldError', { field: namesLbl})}
                            </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="12" controlId="phoneReg">
                        <Form.Label>{t('forms.phone')}*</Form.Label>
                        <Form.Control
                            type="text"
                            name="phoneNumber"
                            required={visibleErrors}
                        />
                        <Form.Control.Feedback type="invalid">
                                {t('forms.requiredFieldError', { field: t('forms.phone')})}
                        </Form.Control.Feedback>
                    </Form.Group>

                                  
                    
                    <Form.Group as={Col} xs="12" controlId="validationCustom08">
                        <div className='align-center btn-out margin-0'>
                            <Button type="submit">{sendLbl}</Button>
                        </div>
                    </Form.Group>
                    <SocialButtons />
                </Col>
                <Col lg="6">
                    <Form.Group as={Col} md="12" controlId="message">
                        <Form.Label>{messageLbl}*</Form.Label>
                        <Form.Control as="textarea" name="message" rows={8} required={visibleErrors} />
                            <Form.Control.Feedback type="invalid">
                                {t('forms.requiredFieldError', { field: messageLbl})}
                        </Form.Control.Feedback>
                    </Form.Group>  
                </Col>
            </Row>
        </Form>
        {isSpinning ? (
            <SpinLoader />
        ) : null}
    </div>
  );
}

export default ContactForm;